import {Component, ComponentFactoryResolver, EventEmitter, Injectable, ViewContainerRef} from '@angular/core';
import {ButtonComponent} from "../../test/button-component/button-component.component";
import {Dialog} from "../../shared/dialog/dialog";

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  
  modalEventEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor(private resolver: ComponentFactoryResolver ) {}

  emitModalEvent(data: any) {
    this.modalEventEmitter.emit(data);
  }

  createDialog(component, data, entry: ViewContainerRef)  {

    //console.log("Calling createDialog");

    const resolver = this.resolver;

    return new Promise(function(resolve, reject) {
      const factory = resolver.resolveComponentFactory<Dialog>(component);
      const injectedComponent = entry.createComponent<Dialog>(factory);

      injectedComponent.instance.data = data;
      injectedComponent.instance.remove.subscribe(returnData => {
        injectedComponent.destroy();

        if(returnData){
          resolve(returnData);
        } else {
          reject(returnData);
        }
      })
    })
  }

}
